<template>
  <ReviewsProductInsightsBuyer :kpi="view" :loading="loading" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { type ProductById, useBuyerInsightsQuery } from '@/gql/reviews'
import { mapBuyerInsights } from '@/gql/reviews/mappers/insights'

import { useRouterQueryInsightsTimeframe } from '../useRouterQueryInsightsTimeframe'
import ReviewsProductInsightsBuyer from './ReviewsProductInsightsBuyer.vue'

const props = defineProps<{ product: ProductById }>()

const { locale } = useI18n()
const { periodPreset } = useRouterQueryInsightsTimeframe()

const { result, loading } = useBuyerInsightsQuery(() => ({ productSlug: props.product.slug, period: periodPreset.value }), {
  clientId: 'reviews',
  keepPreviousResult: true,
  fetchPolicy: 'cache-first',
})

const view = computed(() => mapBuyerInsights(result.value, { locale: locale.value }))
</script>
